/**
 * Configures the router with the legacy routes.
 * @param {ngRouteProvider} $routeProvider The interface for the AngularJS router.
 * @ngesdoc config
 * @ngprovider $routeProvider
 * @ngmodule legacy
 */
const routeProviderConfig = ($routeProvider) => {
  'ngInject';

  $routeProvider
  // Request a password reset using the referrer instead of the SSO state.
  .when('/l/remember-password', {
    template: '<remember-password-legacy-container></remember-password-legacy-container>',
  });
};

export default routeProviderConfig;
